export class CsvParserData {
  public error: any[];
  public result: any[];
}
